import React, { useEffect, useRef } from 'react';
import './estrategiasIDI.scss';
import fotoEstrategicos from '../../../media/img/i+d+i/idi_neurocinema.jpg';
import fotoMetodologia from '../../../media/img/i+d+i/idi_metodologia.jpg';
import fotoColaboraciones from '../../../media/img/i+d+i/idi_colaboraciones.jpg';
import crecimiento from '../../../media/img/i+d+i/crecimientogris.png';

const EstrategiasIDI = () => {
  const lineRefs = useRef([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px 0px 0px',
    };

    const lineObservers = lineRefs.current.map((lineRef) => {
      if (!lineRef) return null;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('content__title-line--visible');
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);
      observer.observe(lineRef);
      return observer;
    });

    return () => {
      lineObservers.forEach((obs) => obs?.disconnect());
    };
  }, []);

  return (
    <div className="estrategiasIDI">
      <section className="estrategiasIDI__container">
        <div className="estrategiasIDI__header">
          <h1 className="estrategiasIDI__title">
            METODOLOGÍA WONDERALY DE I+D+i
          </h1>
          <div
            ref={(el) => (lineRefs.current[0] = el)}
            className="content__title-line"
          />
          <h2 className="estrategiasIDI__subtitle content__subtitle-backgroundDark">
            Del análisis neuropsicológico a la producción audiovisual: así
            transformamos la ciencia en resultados reales
          </h2>
          <p className="estrategiasIDI__text content__text-title-backgroundDark">
            En WONDERALY INNOVATIONS aplicamos nuestra I+D+i con un enfoque
            científico, práctico y colaborativo. Integramos neuropsicología, IA
            y Business Intelligence en cada fase del proceso audiovisual para
            generar impacto emocional medible, optimizar la toma de decisiones
            creativas y desarrollar proyectos con impacto social real.
          </p>
        </div>
        <div className="estrategiasIDI__grid">
          <div className="estrategiasIDI__card">
            <div className="estrategiasIDI__grid-textcontainer">
              <h3 className="estrategiasIDI__grid-title">
                Ámbitos de Aplicación Neurocinema
              </h3>
              <p className="estrategiasIDI__grid-descripcion">
                Aplicamos la neuropsicología científica en las cuatro fases
                clave de la producción audiovisual.
              </p>
              <ul className="estrategiasIDI__grid-list">
                <li className="estrategiasIDI__grid-item">
                  Preproducción: diseño narrativo y construcción de personajes
                </li>
                <li className="estrategiasIDI__grid-item">
                  Rodaje: dirección neuroefectiva y comunicación de equipo
                </li>
                <li className="estrategiasIDI__grid-item">
                  Postproducción: montaje basado en arousal emocional
                </li>
                <li className="estrategiasIDI__grid-item">
                  Distribución: análisis predictivo de respuesta del público
                </li>
              </ul>
            </div>
            <div className="estrategiasIDI__grid-imagencontainer">
              <img
                className="estrategiasIDI__grid-imagen"
                src={fotoEstrategicos}
                alt="Ámbitos Neurocinema"
              />
            </div>
          </div>

          <div className="estrategiasIDI__card estrategiasIDI__card-flex-row-reverse">
            <div className="estrategiasIDI__grid-textcontainer">
              <h3 className="estrategiasIDI__grid-title">
                Metodología Wonderaly para Proyectos
              </h3>
              <p className="estrategiasIDI__grid-descripcion">
                Combinamos rigor científico, análisis de datos y acompañamiento
                personalizado para garantizar resultados tangibles en cada
                producción.
              </p>
              <ul className="estrategiasIDI__grid-list">
                <li className="estrategiasIDI__grid-item">
                  Diagnóstico neuropsicológico inicial del proyecto
                </li>
                <li className="estrategiasIDI__grid-item">
                  Desarrollo de informes científicos y recomendaciones
                </li>
                <li className="estrategiasIDI__grid-item">
                  Implementación progresiva en cada fase de producción
                </li>
                <li className="estrategiasIDI__grid-item">
                  Seguimiento continuo con BI e informes en tiempo real
                </li>
              </ul>
            </div>
            <div className="estrategiasIDI__grid-imagencontainer">
              <img
                className="estrategiasIDI__grid-imagen"
                src={fotoMetodologia}
                alt="Metodología Wonderaly"
              />
            </div>
          </div>

          <div className="estrategiasIDI__card">
            <div className="estrategiasIDI__grid-textcontainer">
              <h3 className="estrategiasIDI__grid-title">
                Colaboraciones e Impacto Social
              </h3>
              <p className="estrategiasIDI__grid-descripcion">
                Creemos en el poder de la colaboración para transformar
                industrias y salvar vidas.
              </p>
              <ul className="estrategiasIDI__grid-list">
                <li className="estrategiasIDI__grid-item">
                  Centros de investigación y universidades especializadas
                </li>
                <li className="estrategiasIDI__grid-item">
                  Instituciones educativas y servicios de salud
                </li>
                <li className="estrategiasIDI__grid-item">
                  Productoras y asociaciones del sector audiovisual
                </li>
                <li className="estrategiasIDI__grid-item">
                  Proyectos de impacto social como Prevención del Suicidio en
                  Extremadura
                </li>
              </ul>
            </div>
            <div className="estrategiasIDI__grid-imagencontainer">
              <img
                className="estrategiasIDI__grid-imagen"
                src={fotoColaboraciones}
                alt="Colaboraciones Wonderaly"
              />
            </div>
          </div>
        </div>

        <div className="estrategiasIDI__vision">
          <div className="estrategiasIDI__visioncontainers">
            <h1 className="estrategiasIDI__vision-title content__title-backgroundDark">
              Innovación
            </h1>
            <div
              ref={(el) => (lineRefs.current[1] = el)}
              className="content__title-line"
            />
            <h2 className="estrategiasIDI__vision-subtitle content__subtitle-backgroundDark">
              con visión científica y humana
            </h2>
          </div>
          <div className="estrategiasIDI__visioncontainers">
            <p className="estrategiasIDI__vision-text">
              Nuestra I+D+i no es teórica — está diseñada para transformar
              producciones audiovisuales y generar impacto social real.
              Innovamos para que directores, productores e instituciones puedan
              crear con mayor profundidad emocional, precisión científica y
              confianza en cada decisión.
            </p>
          </div>
          <div className="estrategiasIDI__vision-imgContainer">
            <img
              className="estrategiasIDI__vision-img"
              src={crecimiento}
              alt="Innovación Wonderaly"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default EstrategiasIDI;
